import SupportLanguage from './SupportLanguage';

const fallbackLanguages: { [language: string]: string } = {
    en: SupportLanguage.ENG,
    'en-US': SupportLanguage.ENG,
    'en-EG': SupportLanguage.ENG,
    'en-AU': SupportLanguage.ENG,
    'en-GB': SupportLanguage.ENG,
    'en-CA': SupportLanguage.ENG,
    'en-NZ': SupportLanguage.ENG,
    'en-IE': SupportLanguage.ENG,
    'en-ZA': SupportLanguage.ENG,
    'en-JM': SupportLanguage.ENG,
    'en-BZ': SupportLanguage.ENG,
    'en-TT': SupportLanguage.ENG,
    'zh-cn': SupportLanguage.SCH,
    'zh-CN': SupportLanguage.SCH,
    'zh-SG': SupportLanguage.SCH,
    'zh-chs': SupportLanguage.SCH,
    cn: SupportLanguage.SCH,
    'zh-hk': SupportLanguage.HKT,
    hk: SupportLanguage.HKT,
    'zh-tw': SupportLanguage.TCH,
    'zh-TW': SupportLanguage.TCH,
    'zh-HK': SupportLanguage.HKT,
    'zh-MO': SupportLanguage.TCH,
    'zh-cht': SupportLanguage.TCH,
    tw: SupportLanguage.TCH,
    jpn: SupportLanguage.JP,
    kr: SupportLanguage.KR,
    kor: SupportLanguage.KR,
    ind: SupportLanguage.ID,
    vie: SupportLanguage.VI,
    tha: SupportLanguage.TH,
    'pt-br': SupportLanguage.PT,
    de: SupportLanguage.DE,
};

export default fallbackLanguages;
